import { Component, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';
import { OfflineService } from 'src/app/offline/offline.service';
import { TrackingDashboardSearchHandler } from './tracking-dashboard-chart.handler';

@Component({
  selector: 'sym-tracking-dashboard-chart',
  templateUrl: './tracking-dashboard-chart.component.html',
  styleUrls: ['./tracking-dashboard-chart.component.scss'],
})
export class TrackingDashboardSearchComponent extends TrackingDashboardSearchHandler {
  constructor(
    public agentService: ContestAndIncentiveDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(agentService, headerService, router, settingService, offlineService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
